import React, { useState } from "react";

export const MessageContext = React.createContext();

export const MessageProvider = ({ children }) => {
	const [chatMessage, setChatMessage] = useState("");

	return (
		<MessageContext.Provider value={{ chatMessage, setChatMessage }}>
			{children}
		</MessageContext.Provider>
	);
};
